import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link } from "gatsby";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { blueGrey } from "@mui/material/colors";
import { graphql } from "gatsby";
import Layout from "../../components/layout";
import StoryComponent from "../../components/articles/story/StoryComponent";
import ArticleAuthorCard from "../../components/articles/sideBar/ArticleAuthorCard";
import MentionedProducts from "../../components/articles/sideBar/MentionedProducts";
import RelatedProducts from "../../components/articles/sideBar/RelatedProducts";
import Tags from "../../components/articles/story/Tags";
import Seo from "../../components/seo";
import { Script } from "gatsby";
import RelatedPosts from "../../components/articles/sideBar/ReleatedPosts";

const bgColor = blueGrey[50];
const theme = createTheme({
  typography: {
    h1: {
      fontFamily: "raleway",
      fontWeight: 500,
      fontSize: "2.4rem",
      color: "#303030",
    },
    h2: {
      color: "#B05F46",
      fontWeight: 600,
      fontFamily: "raleway",
      fontSize: "1.7rem",
    },
    h2Side: {
      fontFamily: "raleway",
      fontWeight: 600,
      fontSize: "1.2rem",
    },
    h3: {
      fontWeight: 450,
      fontSize: "1.1rem",
    },
    h4: {
      fontWeight: 600,
      fontFamily: "raleway",
      color: "#303030",
      fontSize: "1.1rem",
    },
    h5: {
      fontWeight: 500,
      fontSize: "0.875rem",
    },
    h5ProductListing: {
      fontWeight: 500,
      color: "black",
      fontSize: "0.875rem",
    },
    h6: {
      fontWeight: 500,
      fontSize: "0.875rem",
    },
    h6press: {
      color: "#718096",
      fontWeight: 500,
      fontSize: "1.1rem",
    },
    h7a: {
      fontWeight: 500,
      color: "#919191",
      fontSize: "1.4rem",
    },
    h7b: {
      fontWeight: 500,
      color: "#37817a",
      fontSize: "1.4rem",
    },
    h7title: {
      fontWeight: 500,
      fontSize: ".95rem",
    },
    h7press: {
      fontWeight: 500,
      fontSize: ".875rem",
    },
    h8: {
      color: "#272727",
      fontWeight: 400,
      fontSize: "0.7rem",
    },
    h8b: {
      color: "#9e9e9e",
      fontWeight: 400,
      fontSize: "0.7rem",
    },
    h9: {
      color: "#303030",
      fontWeight: 500,
      fontSize: "0.7rem",
    },
    h10: {
      color: "#4F5968",
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    h11: {
      color: "#718096",
      fontWeight: 500,
      fontSize: "0.8rem",
    },
    h10N: {
      color: "#718096",
      fontWeight: 400,
      fontSize: "0.7rem",
    },
    h11N: {
      color: "#718096",
      fontWeight: 400,
      fontSize: "0.7rem",
    },
    p: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.8",
    },
    pPress: {
      color: "#718096",
      fontWeight: 400,
      fontSize: "0.875rem",
    },
  },
  body: {
    background: bgColor,
  },
  Media: {
    height: 300,
    width: "100%",
    objectFit: "cover",
  },
});
export const query = graphql`
  query ($id: String) {
    strapiArticle(id: { eq: $id }) {
      path: gatsbyPath(filePath: "/library/{StrapiArticle.title}")
      authors {
        path: gatsbyPath(filePath: "/authors/{StrapiAuthor.name}")
        name
        social {
          value
        }
        title
        strapi_id
        thumbnail {
          url
        }
      }
      youtubeEmbedURL
      title
      textPreview
      featuredImageAltText
      featuredImage {
        url
        localFile {
          url
        }
      }
      textPreview
      updatedAt(formatString: "MMMM Do, YYYY")
      updatedJson: updatedAt
      strapi_id
      publishedAt(formatString: "MMMM Do, YYYY")
      publishedJSON: publishedAt
      categoryTag {
        path: gatsbyPath(
          filePath: "/legal-technology-centers/{StrapiProductCategory.name}"
        )
        strapi_id
        name
      }
      body {
        data {
          body
        }
      }
      productTags {
        name
        path: gatsbyPath(filePath: "/products/{StrapiProductListing.slug}")
        strapi_id
        productLogoURL
        productLogo {
          url
          name
          size
          strapi_id
          id
        }
      }
      articleCategory {
        path: gatsbyPath(filePath: "/resources/{StrapiCategory.name}")
        color
        name
        strapi_id
      }
      subCategoryTags {
        path: gatsbyPath(
          filePath: "/categories/{StrapiProductSubCategory.slug}"
        )
        strapi_id
        name
        sponsoredListing {
          name
          slug
          path: gatsbyPath(filePath: "/products/{StrapiProductListing.slug}")
          productLogo {
            url
          }
          productLogoURL
          strapi_id
          companyName
          overallRating
          numberOfReviews
        }
      }
    }
    allStrapiArticle(sort: { publishedAt: DESC }) {
      nodes {
        path: gatsbyPath(filePath: "/library/{StrapiArticle.title}")
        authors {
          path: gatsbyPath(filePath: "/authors/{StrapiAuthor.name}")
          name
          title
          strapi_id
          thumbnail {
            url
          }
        }
        title
        textPreview
        featuredImageAltText
        featuredImage {
          url
        }
        textPreview
        updatedAt(formatString: "MMMM Do, YYYY")
        strapi_id
        publishedAt(formatString: "MMMM Do, YYYY")
        categoryTag {
          path: gatsbyPath(
            filePath: "/legal-technology-centers/{StrapiProductCategory.name}"
          )
          strapi_id
          name
        }
        body {
          data {
            body
          }
        }
        productTags {
          name
          path: gatsbyPath(filePath: "/products/{StrapiProductListing.slug}")
          slug
          strapi_id
          productLogoURL
          productLogo {
            url
            name
            size
            strapi_id
            id
          }
        }
        articleCategory {
          path: gatsbyPath(filePath: "/resources/{StrapiCategory.name}")
          color
          name
          strapi_id
        }
        subCategoryTags {
          path: gatsbyPath(
            filePath: "/categories/{StrapiProductSubCategory.slug}"
          )
          strapi_id
          name
        }
      }
    }
    allStrapiProductListing {
      nodes {
        path: gatsbyPath(filePath: "/products/{StrapiProductListing.slug}")
        name
        completionScore
        slug
        id
        primaryProductCategory {
          name
          id
          strapi_id
        }
        primaryProductSubCategory {
          name
          id
          strapi_id
          productCategory {
            id
            name
            strapi_id
          }
        }
        strapi_id
        secondaryProductSubCategories {
          feature_category {
            name
            id
            strapi_id
          }
          id
          name
          strapi_id
          productCategory {
            id
            name
            strapi_id
          }
        }
        productLogoURL
        productLogo {
          url
          name
          size
          strapi_id
          id
        }
        overallRating
        numberOfReviews
      }
    }
  }
`;

const baseURL = "https://directory.lawnext.com";

export default function LibraryArticle(props) {
  const url = props.location.href;
  const authorsProp = props.data.strapiArticle.authors;

  const isBrowser = typeof window !== "undefined";
  const currentYear = new Date().getFullYear();

  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Seo
          title={`${props.data.strapiArticle.title} ${currentYear} | LawNext Directory`}
          description={`${props.data.strapiArticle.title} ${currentYear} | LawNext Directory`}
        >
          <script type="application/ld+json">
            {`{"@context": "https://schema.org",
      "@type": "Article",
      "headline": "${props.data.strapiArticle.title}",
      ${
        props.data.strapiArticle.featuredImage
          ? `"image": "${props.data.strapiArticle.featuredImage.localFile.url}",`
          : ""
      }
      "datePublished": "${props.data.strapiArticle.publishedJSON}",
      "dateModified": "${props.data.strapiArticle.updatedJson}",
      "author": [{
          "@type": "Person",
          "name": "${authorsProp[0].name}",
          "url": "${baseURL + authorsProp[0].path}"
        }]
    }`}
          </script>
          <script type="application/ld+json">
            {`{
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": 
                                [{
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "authors",
                                    "item": "${baseURL + "/authors/"}"
                                },{
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "${
                                      props.data.strapiArticle.articleCategory
                                        .name
                                    }",
                                    "item": "${
                                      baseURL +
                                      props.data.strapiArticle.articleCategory
                                        .path
                                    }"
                                },{
                                    "@type": "ListItem",
                                    "position": 3,
                                    "name": "${props.data.strapiArticle.title}"
                                }]
                        }`}
          </script>
        </Seo>
        <Script>
          {isBrowser
            ? window.dataLayer.push({
                event: "content_view",
                Author_Name: authorsProp[0].name,
                Content_Name: props.data.strapiArticle.title,
                block: "article_view",
              })
            : ""}
        </Script>

        <Container component="main" style={{ background: bgColor }}>
          <CssBaseline style={{ background: bgColor }} />
          <Box
            sx={{
              marginTop: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ mt: 5, mb: 5, overflow: "visible" }}>
              <Breadcrumbs
                aria-label="breadcrumb"
                sx={{ ml: { xs: 2, md: 5 } }}
              >
                <Link underline="hover" color="inherit" to="/">
                  <Typography variant="p" color="text.primary">
                    Home
                  </Typography>
                </Link>
                <Link underline="hover" color="inherit" to="/tags/">
                  <Typography variant="p" color="text.primary">
                    Tags
                  </Typography>
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  to={props.data.strapiArticle.articleCategory.path}
                >
                  <Typography variant="p" color="text.primary">
                    {props.data.strapiArticle.articleCategory.name}
                  </Typography>
                </Link>
                <Typography variant="p" color="text.primary">
                  {props.data.strapiArticle.title}
                </Typography>
              </Breadcrumbs>
              <Tags strapiArticle={props.data.strapiArticle}/>
              <Grid container rowSpacing={1} columnSpacing={3} sx={{ mt: 2 }}>
                <Grid
                  item
                  container
                  columnSpacing={2}
                  rowSpacing={2}
                  xs={12}
                  md={8}
                >
                  {/******************************* Story */}
                  <Grid
                    container
                    item
                    spacing={2}
                    direction="row"
                    alignItems="stretch"
                  >
                    <Grid item xs={12}>
                        <StoryComponent article={props.data.strapiArticle} url={url}/>
                    </Grid>
                  </Grid>
                </Grid>

                {/*SIDE TRAY*******************************/}
                {/******************************* Review */}
                <Grid
                  item
                  container
                  direction="column"
                  spacing={1}
                  xs={12}
                  md={3.5}
                >
                  <Grid item xs={"auto"} sx={{ width: "100%" }}>
                          <ArticleAuthorCard articleAuthors={props.data.strapiArticle.authors}/>
                  </Grid>
                  <Grid item xs={"auto"}>
                    <MentionedProducts strapiArticle={props.data.strapiArticle}/>
                  </Grid>
                  <Grid item xs={"auto"}>
                    <RelatedProducts strapiArticle={props.data.strapiArticle} productsArray={props.data.allStrapiProductListing.nodes}/>
                  </Grid>
                  <Grid item xs={"auto"}>
                          <RelatedPosts strapiArticle={props.data.strapiArticle} articlesArray={props.data.allStrapiArticle.nodes}/>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Layout>
    </ThemeProvider>
  );
}

